export default "__VITE_ASSET__9b04c53a__"